interface PercentageProps {
  className?: string;
  percentage: number;
}

export const Percentage = ({ percentage, className }: PercentageProps) => {
  // if (percentage === 0) {
  //   return <span className={className}>missing</span>;
  // }
  const percentageStr =
    percentage % 1 > 0.1 || percentage >= 1
      ? percentage.toFixed(1)
      : percentage?.toPrecision(1) ?? 0;

  return <span className={className}>{percentageStr}%</span>;
};
